import { Text, type TextProps } from "./Text"

import "./Text.less"

export function TextBodyMono({ className, ...props }: TextProps) {
  return <Text className={`TextBodyMono ${className || ""}`} {...props} />
}
